import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Select, Icon, Avatar } from "antd";
import UsersService from "../../services/user";
import { debounce } from "../../utils/debounce";
import "./SelectReceivers.scss";

import DefaultUserImage from "../../assets/img/avatar_user_black.png";
import { ReactComponent as AddSvg } from "../../assets/icon/ic_add_24dp.svg";
import { ReactComponent as CancelSvg } from "../../assets/icon/ic_cancel_24dp.svg";
import { ReactComponent as WarningSvg } from "../../assets/icon/ic_warning_24dp.svg";

const Option = Select.Option;

function SelectedUsers({ users, onClose, disabled, getUserAvatar }) {
  let localSelectedUsers = [];
  for (let i in users) {
    let user = users[i];
    if (user.user) {
      user = user.user;
    }
    localSelectedUsers.push(
      <div className="selected-user" key={user.username}>
        <Avatar src={getUserAvatar(user)} />
        <span className="selected-user-username">@{user.username}</span>
        <span className="selected-user-name" title={user.name}>
          {user.name}
        </span>
        <div className="selected-user-icon-container">
          {user.away ? <Icon className="away" component={WarningSvg} /> : false}
          {disabled ? (
            false
          ) : (
            <Icon
              className="filled-button"
              component={CancelSvg}
              onClick={(e) => onClose(e, user.username)}
            />
          )}
        </div>
      </div>
    );
  }
  return localSelectedUsers;
}

class SelectReceivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUsers: {},
      usersToSelect: [],
      value: [],
      inputValue: "",
    };
    this.onSelect = this.onSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getNotFoundContentString = this.getNotFoundContentString.bind(this);
    this.onClose = this.onClose.bind(this);
    this.setListRef = this.setListRef.bind(this);
  }

  componentDidMount() {
    const { draft } = this.props;
    if (draft && draft.recipients) {
      this.setState({
        selectedUsers: draft.recipients,
      });
    }
    if (this.props.recipients) {
      let selectedUsers = this.props.recipients.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {});
      this.setState({
        selectedUsers: selectedUsers,
      });
    }
  }

  componentWillUnmount() {
    this.debounceChange.clear();
  }

  handleSearch(value) {
    this.debounceChange(value);
  }

  debounceChange = debounce((value) => {
    if (value.length > 0) {
      UsersService.getUsers({ name: value }).then((res) =>
        this.setState({
          usersToSelect: res && res.data && res.data.content,
          inputValue: value,
        })
      );
    } else {
      this.setState({
        usersToSelect: [],
        inputValue: value,
      });
    }
  }, 500);

  onSelect(value, option) {
    let localSelectedUsers = this.removeReactivity(this.state.selectedUsers);
    localSelectedUsers[option.key] = this.state.usersToSelect.find(
      (elem) => elem.username === option.key
    );
    this.props.onSelectedUsersChange(localSelectedUsers);
    this.setState({
      selectedUsers: localSelectedUsers,
      usersToSelect: [],
      inputValue: "",
    });
  }

  onClose(e, username) {
    e.stopPropagation();
    let localSelectedUsers = this.removeReactivity(this.state.selectedUsers);
    delete localSelectedUsers[username];
    this.props.onSelectedUsersChange(localSelectedUsers);
    this.setState({
      selectedUsers: localSelectedUsers,
    });
  }

  removeReactivity(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  setListRef(node) {
    this.listRef = node;
  }

  getStatus(user) {
    if (user && !user.away) {
      return false;
    }

    return <Icon className="away" component={WarningSvg} />;
  }

  getUserAvatar(user) {
    return DefaultUserImage;
  }

  getNotFoundContentString() {
    return this.state.inputValue && this.state.inputValue.length > 0 ? (
      <FormattedMessage id="chat.userNotFound" />
    ) : (
      <FormattedMessage id="chat.typeUserName" />
    );
  }

  render() {
    const options =
      this.state.usersToSelect &&
      this.state.usersToSelect.map((user) => (
        <Option
          key={user.username}
          username={"@" + user.username}
          name={user.name}
          value={"@" + user.username + " - " + user.name}
        >
          <Avatar src={this.getUserAvatar(user)} />
          <div className="user-description">
            <span className="title">@{user.username}</span>
            <span className="description">{user.name}</span>
            {this.getStatus(user)}
          </div>
        </Option>
      ));
    return (
      <div className="select-receivers">
        <div className="selected-users">
          <SelectedUsers
            users={this.state.selectedUsers}
            onClose={this.onClose}
            disabled={this.props.disabled}
            getUserAvatar={this.getUserAvatar}
          />
        </div>
        <div className="input-user">
          <Icon className="plus-icon" component={AddSvg} />
          <Select
            mode="multiple"
            value={this.state.value}
            style={{ width: "100%" }}
            placeholder={<FormattedMessage id="chat.sendTo" />}
            notFoundContent={this.getNotFoundContentString()}
            optionLabelProp="username"
            dropdownMatchSelectWidth={false}
            dropdownClassName="select-receivers-dropdown"
            getPopupContainer={() => this.listRef}
            disabled={this.props.disabled}
            filterOption={false}
            onSelect={this.onSelect}
            onSearch={this.handleSearch}
          >
            {options}
          </Select>
          <div className="dropdown-container" ref={this.setListRef} />
        </div>
      </div>
    );
  }
}

export default SelectReceivers;
